import { GetPickupSlotsQuery } from "./get-pickup-slots-query";
import { IPickupSlot, PickupSlot } from "../../../../front-office/model/pickup-slot";
import { httpGet } from "../../../network/fetch";

export const GetPickupSlotHandler = async (command: GetPickupSlotsQuery) => {
    return (await httpGet<{ pickupSlots: IPickupSlot[] } | undefined>({
        url: `/pickup-slots/warehouse/${command.warehouseCode}/list?`
            + (command.palletIdsList.length > 0 ? command.palletIdsList.map((id, index) =>
                `&palletsIds[${index}]=${id}`).join("") : "")
            + (command.departureDate ? `&departureDate=${command.departureDate.format("YYYY-MM-DD")}` : ""),
    }))?.pickupSlots.map(ps => new PickupSlot(ps)) ?? [];
};
